import { NAV_PATHS } from '@modules/common/constants';
import { WORKSPACE_MENU_SECTIONS_CONFIG_URLS } from '@modules/workspaceSettings/constants';
import { useIsFeedbackTranslationsEnabled } from '@modules/workspaceSettings/hooks/useIsFeedbackTranslationsEnabled';
import { Navigate, useParams } from 'react-router-dom';
import { WorkspaceSettingsBodyContent } from './WorkspaceSettingsBodyContent';

interface WorkspaceSettingsBodyProps {
  isOnboardingPageVariant: boolean;
}

export const WorkspaceSettingsBody = ({
  isOnboardingPageVariant,
}: WorkspaceSettingsBodyProps) => {
  const { workspaceSettingName: workspaceSettingNameFromURL } =
    useParams<{ workspaceSettingName: string }>();

  const isValidWorkspaceSetting = Object.values(
    WORKSPACE_MENU_SECTIONS_CONFIG_URLS,
  ).includes(workspaceSettingNameFromURL ?? '');

  const isFeedbackTranslationsEnabled = useIsFeedbackTranslationsEnabled();

  const shouldNavigateToDefaultPage =
    !workspaceSettingNameFromURL ||
    (workspaceSettingNameFromURL ===
      WORKSPACE_MENU_SECTIONS_CONFIG_URLS.FEEDBACK_TRANSLATIONS &&
      !isFeedbackTranslationsEnabled);

  if (shouldNavigateToDefaultPage) {
    return (
      <Navigate
        to={`/${NAV_PATHS.WORKSPACE_SETTINGS}/${WORKSPACE_MENU_SECTIONS_CONFIG_URLS.SSO_SETTINGS}`}
        replace
      />
    );
  }

  return (
    <WorkspaceSettingsBodyContent
      workspaceSettingNameFromURL={workspaceSettingNameFromURL}
      isValidWorkspaceSetting={isValidWorkspaceSetting}
      isOnboardingPageVariant={isOnboardingPageVariant}
    />
  );
};
